import Golf6 from "../images/cars-big/golf6.jpg";
import AudiA1 from "../images/cars-big/audia1.jpg";
import Toyota from "../images/cars-big/toyotacamry.jpg";
import Bmw320 from "../images/cars-big/bmw320.jpg";
import Benz from "../images/cars-big/benz.jpg";
import Passat from "../images/cars-big/passatcc.jpg";

export const CAR_DATA = [
  [
    {
      name: "VW Golf 6",
      price: "37",
      img: Golf6,
      model: "Golf 6",
      mark: "Volkswagen",
      year: "2008",
      doors: "4/5",
      air: "Oui",
      transmission: "Manuelle",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Audi A1 S-Line",
      price: "45",
      img: AudiA1,
      model: "Audi",
      mark: "A1",
      year: "2012",
      doors: "4/5",
      air: "Oui",
      transmission: "Manuelle",
      fuel: "Essence",
    },
  ],
  [
    {
      name: "Toyota Camry",
      price: "30",
      img: Toyota,
      model: "Camry",
      mark: "Toyota",
      year: "2006",
      doors: "4/5",
      air: "Oui",
      transmission: "Automatique",
      fuel: "Hybrid",
    },
  ],
  [
    {
      name: "BMW 320 ModernLine",
      price: "35",
      img: Bmw320,
      model: "320",
      mark: "BMW",
      year: "2012",
      doors: "4/5",
      air: "Oui",
      transmission: "Manuelle",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "Mercedes-Benz GLK",
      price: "50",
      img: Benz,
      model: "Benz GLK",
      mark: "Mercedes",
      year: "2006",
      doors: "4/5",
      air: "Oui",
      transmission: "Manuelle",
      fuel: "Diesel",
    },
  ],
  [
    {
      name: "VW Passat CC",
      price: "25",
      img: Passat,
      model: "Passat CC",
      mark: "Volkswagen",
      year: "2008",
      doors: "4/5",
      air: "Oui",
      transmission: "Automatique",
      fuel: "Essence",
    },
  ],
];
